import Vue from 'vue'
import storage from '@/storage'

// 导入ui自带语言包
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import vi from 'element-ui/lib/locale/lang/vi'

// 导入App 语言包
import enApp from './en-US.js'
import zhApp from './zh-CN.js'
import viApp from './vi.js'

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// Ready translated locale messages
const messages = {
  'en-US': Object.assign(en, enApp),
  'zh-CN': Object.assign(zh, zhApp),
  'vi': Object.assign(vi, viApp)
}

// Create VueI18n instance with options
export default new VueI18n({
  locale: storage.get_lang(), // set locale
  messages // set locale messages
})



// WEBPACK FOOTER //
// ./src/lang/index.js